import React, { Component } from "react";
import PortalForm from "../PortalForm";
import RemoveDialog from "../../Shared/Remove/RemoveDialog";
import {
    enabledisableOnRuntime,
    deleteOnRuntime,
} from "../../Helpers/DisableDeleteRuntime";
import { MsalContext } from "@azure/msal-react";
import { getPortals } from "../../../API/Portal/Portal";
import InnerLoader from "../../Shared/Loader/InnerLoader";
import { DeleteFile } from "../../Helpers/DateLakeStorage";
import { OverlayLoader } from "../../Shared/Loader/OverlayLoader";
import Loader from "../../Shared/Loader/loader";
import WorkspaceAppModelContext from "../../../Context/Workspace/WorkspaceAppModelContext";
import { withTranslation } from "react-i18next";
import { getProject } from "../../../API/Project/project";
import { deletePortal, updatePortal } from "../../../API/Portal/Portal";
import SaveDialog from "../../Shared/Remove/SaveDialog";
import { callApiWithAuthorization } from "../../../API/CallApi";

class General extends Component {

    static contextType = MsalContext;

    constructor(props) {
        super(props);
        this.state = {
            portal: { ...this.props.portal },
            Portals: [],
            PortalDisabling: false,
            errorMessage: {
                type: "",
                status: "",
                message: "",
            },
            loading: true,
            PortalDeleting: false,
            DeletePortalPopup: false,
            DisablePortalPopup: false,
            MobilePortalPopup: false,
            RemoveMobilePortalPopup: false,
            hasMobilePortal: this.props.portal.hasMobilePortal || false,
            isMobilePortal: this.props.portal.isMobilePortal || false,
        };
    }

    componentDidMount = async () => {
        let Portals = await getPortals(this.props.project._id);
        const portal = Portals.find(portal => portal._id === this.props.portal._id);
        this.setState({
            loading: false,
            Portals: Portals.reverse(),
            portal,
            hasMobilePortal: portal.hasMobilePortal || false,
            isMobilePortal: portal.isMobilePortal || false
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.portal?._id !== this.props.portal?._id) {
            const portal = this.state.Portals.find(portal => portal._id === this.props.portal._id);
            this.setState({
                portal,
                hasMobilePortal: portal.hasMobilePortal || false,
                isMobilePortal: portal.isMobilePortal || false
            })
        }
    }

    render() {
        const { t } = this.props;
        if (this.state.loading) {
            return <Loader />;
        }
        return (
            <div className="container-fluid">
                {(this.state.PortalDisabling && !this.state.portal.isActive) && <OverlayLoader />}
                <div className="row">
                    {this.state.DeletePortalPopup && (
                        <RemoveDialog
                            showLoader={this.state.PortalDeleting}
                            toggleDeleteDialog={this.toggleDeleteDialog}
                            onDelete={() => this.DeletePortal(this.state.portal)}
                            message={t("dialog.warning", { ns: "portal/delete_portal", portalName: this.state.portal.portalName })}
                            Title={t("dialog.title", { ns: "portal/delete_portal" })}
                            deleteButtonText={t("dialog.buttons.delete_button_label", { ns: "portal/delete_portal" })}
                            cancelButtonText={t("dialog.buttons.cancel_button_label", { ns: "portal/delete_portal" })}
                        />
                    )}
                    {this.state.DisablePortalPopup && (
                        <RemoveDialog
                            showLoader={this.state.PortalDisabling}
                            toggleDeleteDialog={this.toggleDisableDialog}
                            onDelete={() => this.DisablePortal(this.state.portal)}
                            message={t("dialog.warning", { ns: "portal/disable_portal", portalName: this.state.portal.portalName })}
                            Title={t("dialog.title", { ns: "portal/disable_portal" })}
                            deleteButtonText={t("dialog.buttons.disable_button_label", { ns: "portal/disable_portal" })}
                            cancelButtonText={t("dialog.buttons.cancel_button_label", { ns: "portal/disable_portal" })}
                        />
                    )}
                    {this.state.MobilePortalPopup && (
                        <SaveDialog
                            showLoader={false}
                            toggleSaveDialog={this.toggleMobilePortalDialog}
                            onSave={() => this.enableMobilePortal()}
                            onCancel={this.toggleMobilePortalDialog}
                            message={t("dialog.message", { ns: "portal/mobile_portal" })}
                            Title={t("dialog.title", { ns: "portal/mobile_portal" })}
                            SaveButtonText={t("dialog.buttons.enable_button_label", { ns: "portal/mobile_portal" })}
                            cancelButtonText={t("dialog.buttons.cancel_button_label", { ns: "portal/mobile_portal" })}
                        />
                    )}
                    {this.state.RemoveMobilePortalPopup && (
                        <RemoveDialog
                            showLoader={false}
                            toggleDeleteDialog={this.toggleRemoveMobilePortalDialog}
                            onDelete={() => this.removeMobilePortal()}
                            message={t("dialog.warning", { ns: "portal/remove_mobile_portal", portalName: this.state.portal.portalName })}
                            Title={t("dialog.title", { ns: "portal/remove_mobile_portal" })}
                            deleteButtonText={t("dialog.buttons.remove_button_label", { ns: "portal/remove_mobile_portal" })}
                            cancelButtonText={t("dialog.buttons.cancel_button_label", { ns: "portal/remove_mobile_portal" })}
                        />
                    )}
                    <div className="col-md-12 col-lg-7">
                        <div>
                            <form className="py-3 ms-2" onSubmit={this.SavePortal}>
                                <WorkspaceAppModelContext.Consumer>
                                    {
                                        ({ state, mutators }) => (
                                            <PortalForm
                                                organization={this.props.organization}
                                                project={this.props.project}
                                                useSuspense={false}
                                                onCancel={this.toggleCreatePortalDialog}
                                                viewMode={true}
                                                cloneId=""
                                                portal={this.state.portal}
                                                Portals={this.state.Portals}
                                                onSubmit={this.updatePortalValueInState}
                                                mutators={mutators}
                                            />
                                        )
                                    }
                                </WorkspaceAppModelContext.Consumer>
                                {
                                    !this.state.isMobilePortal &&
                                    <>
                                        <div className="overview-divider"></div>
                                        <div className="mt-0 d-inline-block">
                                            <span className="font-size-1 form-label me-2">
                                                {t("general.mobile_portal.header", { ns: "portal/portal_detail" })}
                                            </span>
                                        </div>
                                        <div className="py-2">
                                            <div className="mb-2">
                                                {t("general.mobile_portal.enable_mobile_portal_label", { ns: "portal/portal_detail" })}
                                            </div>
                                            {this.state.hasMobilePortal ? (
                                                <button
                                                    className="btn btn-success"
                                                    onClick={() => {
                                                        const portal = this.state.Portals.find(portal => portal._id === this.state.portal.mobilePortalId);
                                                        this.props.setSelectedPortal(portal)
                                                    }}
                                                    type="button"
                                                >
                                                    <i className="fa-solid fa-arrow-up-right-from-square" />
                                                    &nbsp;{t("general.mobile_portal.navigate_to_mobile_portal_button", { ns: "portal/portal_detail" })}
                                                </button>
                                            ) : (
                                                <button
                                                    type="button"
                                                    onClick={this.toggleMobilePortalDialog}
                                                    className="btn btn-primary"
                                                >
                                                    <span className="font-size-1 me-1">
                                                        <i className="fas fa-mobile-alt me-2"></i>
                                                        {t("general.mobile_portal.enable_mobile_portal_button", { ns: "portal/portal_detail" })}
                                                    </span>
                                                </button>
                                            )}
                                        </div>
                                    </>
                                }
                                <div className="overview-divider"></div>
                                {this.state.portal.isActive ? (
                                    <div className="mt-0 d-inline-block">
                                        <span className="font-size-1 form-label me-2">
                                            {t("title", { ns: "portal/disable_portal" })}
                                        </span>
                                        {t("dont_require_publish", { ns: "portal/enable_portal" })}
                                    </div>
                                ) : (
                                    <div className="mt-0 d-inline-block">
                                        <span className="font-size-1 form-label me-2">
                                            {t("title", { ns: "portal/enable_portal" })}
                                        </span>
                                        {t("dont_require_publish", { ns: "portal/enable_portal" })}
                                    </div>
                                )}

                                {!this.state.PortalDisabling &&
                                    this.state.errorMessage &&
                                    this.state.errorMessage.type ===
                                    "Disable" &&
                                    this.state.errorMessage.status ===
                                    "Failure" && (
                                        <span className="ms-2 text-danger d-inline-block">
                                            {
                                                this.state.errorMessage
                                                    .message
                                            }
                                        </span>
                                    )}
                                {this.state.portal.isActive ? (
                                    <div className="py-2">
                                        <span>
                                            {t("description", { ns: "portal/disable_portal" })}
                                        </span>
                                    </div>
                                ) : (
                                    <div className="py-2">
                                        <span>
                                            {t("description", { ns: "portal/enable_portal" })}
                                        </span>
                                    </div>
                                )}

                                <div className="d-flex align-items-center">
                                    <button
                                        type="button"
                                        onClick={this.state.portal.isActive ? this.toggleDisableDialog : () => this.DisablePortal(this.state.portal)}
                                        disabled={this.shouldDisableDisablePortalButton()}
                                        className={this.state.portal.isActive
                                            ? "btn btn-danger"
                                            : "btn btn-success"
                                        }
                                    >
                                        <span className="font-size-1 me-1">
                                            <i className="fas fa-ban me-2"></i>
                                            {this.state.portal.isActive
                                                ?
                                                t("buttons.disable_buttons_label", { ns: "portal/disable_portal" })
                                                :
                                                t("buttons.enable_buttons_label", { ns: "portal/enable_portal" })
                                            }
                                        </span>
                                    </button>
                                    {(this.state.PortalDisabling && !this.state.portal.isActive) && (
                                        <span className="mx-4">
                                            <InnerLoader borderColor={"green"} />
                                            <span className="text-success"></span>
                                        </span>
                                    )}
                                </div>
                                {
                                    !this.state.portal.isActive &&
                                    <>
                                        <div className="overview-divider"></div>
                                        <div>
                                            <span className="form-label me-2">
                                                {t("title", { ns: "portal/delete_portal" })}
                                            </span>
                                            {t("dont_require_publish", { ns: "portal/enable_portal" })}
                                        </div>
                                        <div className="py-2">
                                            <span>
                                                {t("description", { ns: "portal/delete_portal" })}
                                            </span>
                                        </div>

                                        <button
                                            type="button"
                                            onClick={this.toggleDeleteDialog}
                                            disabled={this.shouldDisableDeletePortalButton()}
                                            className="btn btn-danger"
                                        >
                                            <span className="font-size-1 me-1">
                                                <i className="fas fa-trash-can me-2"></i>
                                                {t("buttons.delete_buttons_label", { ns: "portal/delete_portal" })}
                                            </span>
                                        </button>
                                        {this.shouldDisableDeletePortalButton() && (
                                            <span className="ms-2 text-muted">
                                                {t("errors.cannot_delete_only_portal", { ns: "portal/delete_portal" })}
                                            </span>
                                        )}
                                        {!this.state.PortalDeleting &&
                                            this.state.errorMessage &&
                                            this.state.errorMessage.type ===
                                            "Delete" &&
                                            this.state.errorMessage.status ===
                                            "Failure" && (
                                                <span className="ms-2 text-danger ">
                                                    {
                                                        this.state.errorMessage
                                                            .message
                                                    }
                                                </span>
                                            )}
                                    </>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    shouldDisableDisablePortalButton = () => {
        if (this.state.portal.isActive) {
            const hasOnlyOneActivePortal = this.state.Portals.filter(portal => portal.isActive && !portal.isMobilePortal).length === 1
            return (
                this.state.PortalDisabling ||
                (hasOnlyOneActivePortal && !this.state.portal.isMobilePortal)
            );
        }
        return false;
    }

    shouldDisableDeletePortalButton = () => {
        if (this.state.portal.isMobilePortal) {
            return this.state.Portals.length === 1;
        }
        return this.state.Portals.filter(portal => !portal.isMobilePortal).length === 1;
    }

    toggleDeleteDialog = () => {
        this.setState({
            DeletePortalPopup: !this.state.DeletePortalPopup,
        });
    };

    toggleDisableDialog = () => {
        this.setState({
            DisablePortalPopup: !this.state.DisablePortalPopup,
        });
    };

    toggleMobilePortalDialog = () => {
        this.setState({
            MobilePortalPopup: !this.state.MobilePortalPopup,
        });
    };

    toggleRemoveMobilePortalDialog = () => {
        this.setState({
            RemoveMobilePortalPopup: !this.state.RemoveMobilePortalPopup,
        });
    };

    enableMobilePortal = async () => {
        try {
            const request = await callApiWithAuthorization('/api/v0/portal/' + this.state.portal._id + '/mobile', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    projectId: this.props.project._id,
                    properties: {
                        portalName: this.state.portal.portalName.trim().replace(/\s\s+/g, " "),
                        portalDescription: this.state.portal.portalDescription,
                        Icon: this.state.portal.Icon,
                        IconColor: this.state.portal.IconColor,
                        urlName: this.state.portal.urlName,
                        isActive: true,
                        logoUrl: this.state.portal.logoUrl,
                        faviconUrl: this.state.portal.faviconUrl,
                        enableDashboard: true,
                        enableReporting: true,
                        isWorkflowEnabled: true,
                        order: this.state.portal.order,
                        navigationBarOrientation: "Top",
                        navigateToDefaultPage: false,
                        targetPageId: "",
                        isMobilePortal: true,
                    }
                })
            });
            
            const response = await request.json();
            
            if (response && response.status === "Success") {
                // Update local state to reflect mobile portal is enabled
                this.setState({
                    hasMobilePortal: true,
                    mobilePortalId: response.data.portalId,
                    isMobilePortal: false, // Current portal is not the mobile portal
                    MobilePortalPopup: false
                });
                
                // Refresh the portals list to get updated data
                const updatedPortals = await getPortals(this.props.project._id);
                const updatedPortal = updatedPortals.find(portal => portal._id === this.state.portal._id);
                
                this.setState({
                    Portals: updatedPortals.reverse(),
                    portal: updatedPortal
                });
                
                // Update the parent component if needed
                if (this.props.updatePortal) {
                    this.props.updatePortal(updatedPortal);
                }
            } else {
                // Handle error case
                console.error('Failed to enable mobile portal:', response);
            }
        } catch (error) {
            console.error('Error enabling mobile portal:', error);
        }
    };

    removeMobilePortal = async () => {
        const mobilePortal = this.state.Portals.find(portal => portal._id === this.state.portal.mobilePortalId);
        await this.DisablePortal(mobilePortal)
        await this.DeletePortal(mobilePortal, false)
        this.setState({
            hasMobilePortal: false,
            mobilePortalId: "",
            isMobilePortal: false,
            RemoveMobilePortalPopup: false
        });
    }

    DeletePortal = async (dataItem, removePortalSelection = true) => {
        this.setState({
            errorMessage: {
                type: "",
                status: "",
                message: "",
            },
            PortalDeleting: true,
        });
        let type = "Portal";
        let orgId = this.props.organization._id;
        let url = dataItem.urlName;
        let { errorMessage } = this.state;

        let project = await getProject(this.props.project._id);
        let Instances = project.instances;
        for (let instance of Instances) {
            if (instance.Published) {
                if (dataItem.hasMobilePortal && dataItem.mobilePortalId) {
                    await this.removeMobilePortal();
                }
                let result = await deleteOnRuntime(
                    type,
                    url,
                    orgId,
                    instance._id,
                    dataItem._id
                );
                if (result.status === undefined || result.status === "Failure") {
                    if( result.message === "PortalId does not exist") {
                        continue;
                    }
                    errorMessage.status = "Failure";
                    errorMessage.message = result.message;
                    errorMessage.type = "Delete";
                    this.toggleDeleteDialog();
                    this.setState({
                        errorMessage: errorMessage,
                        PortalDeleting: false,
                        DeletePortalPopup: false,
                    });
                    return;
                }
            }
        }

        if (dataItem.faviconUrl !== "") {
            let path = orgId + "/" + this.props.project._id + "/PortalImages/" + dataItem.faviconUrl;
            DeleteFile(path, dataItem.faviconUrl);
        }

        if (dataItem.logoUrl !== "") {
            let path = orgId + "/" + this.props.project._id + "/PortalImages/" + dataItem.logoUrl;
            DeleteFile(path, dataItem.logoUrl);
        }

        await deletePortal(this.props.project._id, dataItem._id, dataItem.portalName);

        if (removePortalSelection) {
            if (
                this.props.workspaceAppModelContext && 
                this.props.workspaceAppModelContext.mutators && 
                this.props.workspaceAppModelContext.mutators.setSelectedPortal 
            ) {
                this.props.workspaceAppModelContext.mutators.setSelectedPortal(null);
            } else {
                window.location.href = `/${this.props.organization.orgName}/${this.props.project.name}/Portals`;
            }
        }
    };

    checkForActivePortal = async (dataItem) => {
        const allPortals = await getPortals(this.props.project._id);

        // Filter out current portal and check if any other portal is active
        const activePortal = allPortals.find(portal => portal._id !== dataItem._id && portal.isActive);

        if (activePortal) {
            return true;
        } else {
            const currentPortal = allPortals.find(portal => portal._id === dataItem._id);

            this.setState({
                Portals: allPortals.slice().reverse(), // Create a copy of allPortals before reversing
                DisablePortalPopup: false,
                PortalDisabling: false,
                portal: { ...currentPortal },
                errorMessage: {
                    type: "Disable",
                    status: "Failure",
                    message: this.props.t("errors.one_active_portal_required"),
                },
            });

            return false;
        }
    };

    DisablePortal = async (dataItem) => {
        this.setState({
            errorMessage: {
                type: "",
                status: "",
                message: "",
            },
            PortalDisabling: true,
        });
        const activePortal = await this.checkForActivePortal(dataItem);
        if (!activePortal) {
            return;
        }
        let { context } = this;
        let type = "Portal";
        let orgId = this.props.organization._id;
        let url = dataItem.urlName;
        let disable = dataItem.isActive;
        let { errorMessage } = this.state;

        const project = await getProject(this.props.project._id);
        const Instances = project.instances;
        for (let instance of Instances) {
            if (instance.Published) {
                let result = await enabledisableOnRuntime(
                    context,
                    type,
                    url,
                    orgId,
                    instance._id,
                    dataItem._id,
                    disable
                );

                if (result.status === undefined || result.status === "Failure") {
                    if( result.message === "PortalId does not exist") {
                        continue;
                    }
                    errorMessage.status = "Failure";
                    errorMessage.message = result.message;
                    errorMessage.type = "Disable";
                    this.setState({
                        errorMessage: errorMessage,
                        PortalDisabling: false,
                        DisablePortalPopup: false, 
                    });
                    return;
                }
            }
        }

        await updatePortal(dataItem._id, { isActive: !dataItem.isActive })

        dataItem.isActive = !dataItem.isActive;

        this.props.portal.isActive = dataItem.isActive;
        const portals = this.state.Portals.map(portal => {
            if (portal._id === dataItem._id) {
                return {
                    ...dataItem
                }
            }
            return portal;
        })

        this.setState({
            Portals: portals,
            portal: { ...this.props.portal },
            PortalDisabling: false,
            DisablePortalPopup: false
        });
    };

    updatePortalValueInState = (updatedPortalValues) => {
        const Portals = this.state.Portals.map(portal => {
            if (portal._id === updatedPortalValues._id) {
                return {
                    ...portal,
                    ...updatedPortalValues
                }
            }
            return portal;
        })
        this.props.updatePortal(updatedPortalValues);
        this.setState({
            portal: { ...this.state.portal, ...updatedPortalValues },
            Portals,
            hasMobilePortal: updatedPortalValues.hasMobilePortal !== undefined ? updatedPortalValues.hasMobilePortal : this.state.hasMobilePortal
        })
    }
}

export default withTranslation([
    "portal/disable_portal",
    "portal/enable_portal",
    "portal/delete_portal",
    "portal/portal_detail",
    "portal/mobile_portal",
    "portal/remove_mobile_portal"
], {
    useSuspense: false,
    withRef: true,
})(General);
